import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { useIsMobile } from "@/hooks/use-mobile";

export const RANGES = [
  { value: "7", label: "7 days" },
  { value: "30", label: "30 days" },
  { value: "90", label: "90 days" },
  { value: "365", label: "1 year" },
];

interface TimeRangeSelectorProps {
  days: number;
  onDaysChange: (days: number) => void;
}

export function TimeRangeSelector({
  days,
  onDaysChange,
}: TimeRangeSelectorProps) {
  const isMobile = useIsMobile();
  const daysStr = String(days);

  return (
    <div className="flex gap-4 items-center">
      <span className="text-sm font-medium text-muted-foreground">
        Time Range:
      </span>
      <ToggleGroup
        type="single"
        value={daysStr}
        onValueChange={(v) => {
          if (v) onDaysChange(Number(v));
        }}
        variant="outline"
        className="hidden *:data-[slot=toggle-group-item]:px-4! @[767px]/main:flex"
      >
        {RANGES.map((r) => (
          <ToggleGroupItem key={r.value} value={r.value}>
            {r.label}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
      <Select value={daysStr} onValueChange={(v) => onDaysChange(Number(v))}>
        <SelectTrigger
          className="flex w-36 **:data-[slot=select-value]:block **:data-[slot=select-value]:truncate @[767px]/main:hidden"
          size="sm"
          aria-label="Select time range"
        >
          <SelectValue placeholder="1 year" />
        </SelectTrigger>
        <SelectContent className="rounded-xl">
          {RANGES.map((r) => (
            <SelectItem key={r.value} value={r.value} className="rounded-lg">
              {r.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
